import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/nhan-su/tai-lieu'

// Lọc tài liệu
export function locTaiLieu(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-tai-lieu`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy tài liệu nhân viên
export function layTaiLieuNhanVien(userId: number, documentType?: string) {
  try {
    const query: any = {}
    if (documentType) query.documentType = documentType
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/tai-lieu`, { params: query })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo tài liệu nhân viên
export function taoTaiLieuNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-tai-lieu-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật tài liệu nhân viên
export function capNhatTaiLieuNhanVien(documentId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${documentId}/cap-nhat-tai-lieu-nhan-vien`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa tài liệu nhân viên
export function xoaTaiLieuNhanVien(documentId: number) {
  try {
    return axiosApi.delete(`${BASE}/${documentId}/xoa-tai-lieu-nhan-vien`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo hàng loạt tài liệu
export function taoHangLoatTaiLieuNhanVien(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-hang-loat-tai-lieu`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
